import type {EntryPoint} from 'react-relay'
import type {LoaderFunctionArgs} from 'react-router'
import {getRequest} from 'relay-runtime'

import {toBuildTypeId} from '../../../types'
import {parseBranch} from '../../../utils/branchNames'
import {makeResource} from '../../../utils/makeResource'
import {getPermalinkLocator} from '../../../utils/permalinks'
import {queryToObject} from '../../../utils/queryParams'

import type {BuildPageComponent} from './BuildPage.container'
import {query} from './BuildPage.queries'
import {getBuildTabsEntryPoints} from './BuildPage.utils'

export function getPermalinkLocatorInLoader({params, request}: LoaderFunctionArgs) {
  const {buildTypeId: buildTypeIdString, buildId} = params
  const buildTypeId = buildTypeIdString != null ? toBuildTypeId(buildTypeIdString) : undefined
  const url = new URL(request.url)
  const {branch} = queryToObject(url.search)
  return buildId != null && buildTypeId != null
    ? getPermalinkLocator(buildId, buildTypeId, parseBranch(branch))
    : null
}

export const BuildPageEntryPoint: EntryPoint<BuildPageComponent, LoaderFunctionArgs> = {
  root: makeResource(
    'BuildPage',
    () => import(/* webpackChunkName: "BuildPage" */ './BuildPage.container'),
  ),
  getPreloadProps(arg) {
    const {params, request} = arg
    const {buildTypeId: buildTypeIdString, buildId} = params
    const buildTypeId = buildTypeIdString != null ? toBuildTypeId(buildTypeIdString) : undefined
    const url = new URL(request.url)
    const {buildTab} = queryToObject(url.search)
    const permalinkLocator = getPermalinkLocatorInLoader(arg)
    const buildLocator = `id:${buildId}`
    const entryPoints =
      buildId != null && permalinkLocator == null
        ? getBuildTabsEntryPoints({arg, buildLocator, buildTab, buildTypeId})
        : {}
    return {
      queries: {
        main: {
          parameters: getRequest(query),
          variables: {
            buildLocator,
            skip: permalinkLocator != null,
          },
          options: {networkCacheConfig: {metadata: {essential: true}}},
        },
      },
      entryPoints,
      extraProps: {permalinkLocator},
    }
  },
}
